// Módulo: Histórico de Compras & Inteligência de Preços
// Responsável pela aba de histórico, cálculo de preço médio e gráficos.

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.suprimentos = window.FazendaRP.Pages.suprimentos || {};

window.FazendaRP.Pages.suprimentos.historico = {
    // State
    selectedItemId: null,
    chartInstance: null,

    // Initial Render
    render: function () {
        return `
            <div id="historico-dashboard" style="background: #f8fafc; padding: 20px; border-radius: 8px;">
                <!-- Header: Item Selector -->
                <div class="hist-header" style="background: white; padding: 20px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 20px;">
                    <label style="display: block; font-size: 0.85rem; font-weight: 600; color: #64748b; margin-bottom: 8px;">Selecione o Item para Análise</label>
                    <select id="hist-item-select" class="form-control" style="width: 100%; padding: 12px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 1rem;">
                        <option value="">Carregando itens...</option>
                    </select>
                </div>

                <!-- Metrics Cards -->
                <div class="hist-metrics" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin-bottom: 20px;">
                    <!-- Avg Price -->
                    <div class="kpi-card" style="background: white; padding: 20px; border-radius: 8px; border-left: 5px solid #3b82f6; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="font-size: 0.85rem; color: #64748b; font-weight: 500;">Preço Médio (Histórico)</div>
                        <div id="kpi-avg-price" style="font-size: 1.8rem; font-weight: 700; color: #1e293b; margin-top: 5px;">R$ 0,00</div>
                        <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 4px;">Ponderado pelo volume</div>
                    </div>
                    
                    <!-- Last Price -->
                    <div class="kpi-card" style="background: white; padding: 20px; border-radius: 8px; border-left: 5px solid #10b981; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="font-size: 0.85rem; color: #64748b; font-weight: 500;">Última Compra</div>
                        <div id="kpi-last-price" style="font-size: 1.8rem; font-weight: 700; color: #1e293b; margin-top: 5px;">R$ 0,00</div>
                        <div id="kpi-last-date" style="font-size: 0.75rem; color: #94a3b8; margin-top: 4px;">-</div>
                    </div>

                    <!-- Total Value -->
                    <div class="kpi-card" style="background: white; padding: 20px; border-radius: 8px; border-left: 5px solid #8b5cf6; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                         <div style="font-size: 0.85rem; color: #64748b; font-weight: 500;">Total Gasto (R$)</div>
                         <div id="kpi-total-spent" style="font-size: 1.8rem; font-weight: 700; color: #1e293b; margin-top: 5px;">R$ 0,00</div>
                         <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 4px;">Acumulado</div>
                    </div>

                    <!-- Total Quantity (NEW) -->
                    <div class="kpi-card" style="background: white; padding: 20px; border-radius: 8px; border-left: 5px solid #f59e0b; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                         <div style="font-size: 0.85rem; color: #64748b; font-weight: 500;">Quantidade Comprada</div>
                         <div id="kpi-total-qty" style="font-size: 1.8rem; font-weight: 700; color: #1e293b; margin-top: 5px;">0</div>
                         <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 4px;">Volume Total</div>
                    </div>
                </div>

                <!-- Content: Table & Chart -->
                <div class="hist-content" style="display: flex; gap: 20px; flex-wrap: wrap;">
                    
                    <!-- Table Section -->
                    <div style="flex: 3; min-width: 400px; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <h4 style="margin-top: 0; color: #334155; margin-bottom: 15px;">Histórico Detalhado</h4>
                        <div style="overflow-x: auto;">
                            <!-- Improved Table Styling -->
                            <table class="table-clean" style="width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.9rem;">
                                <thead>
                                    <tr style="background: #f8fafc; color: #475569; text-align: left;">
                                        <th style="padding: 12px; border-bottom: 2px solid #e2e8f0; font-weight: 600;">Data</th>
                                        <th style="padding: 12px; border-bottom: 2px solid #e2e8f0; font-weight: 600;">Fornecedor</th>
                                        <th style="padding: 12px; border-bottom: 2px solid #e2e8f0; font-weight: 600; text-align: right;">Qtd</th>
                                        <th style="padding: 12px; border-bottom: 2px solid #e2e8f0; font-weight: 600; text-align: right;">Unitário</th>
                                        <th style="padding: 12px; border-bottom: 2px solid #e2e8f0; font-weight: 600; text-align: right;">Total</th>
                                    </tr>
                                </thead>
                                <tbody id="hist-table-body">
                                    <tr><td colspan="5" style="padding: 30px; text-align: center; color: #94a3b8; font-style: italic;">Selecione um item acima para ver o histórico.</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Chart Section -->
                    <div style="flex: 2; min-width: 300px; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <h4 style="margin-top: 0; color: #334155; margin-bottom: 15px;">Evolução do Preço</h4>
                        <div style="height: 300px; position: relative;">
                             <canvas id="hist-price-chart"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        `;
    },

    init: async function (container) {
        // Ensure Items Data is Loaded
        if (!window.FazendaRP.SuprimentosData || window.FazendaRP.SuprimentosData.length === 0) {
            console.log("Histórico: Carregando catálogo de itens...");
            const { data: itens, error } = await window.FazendaRP.supabase
                .from('suprimentos_itens')
                .select('*')
                .neq('status', 'Inativo');

            if (itens) {
                window.FazendaRP.SuprimentosData = itens;
            } else {
                console.error("Histórico: Erro ao carregar itens", error);
            }
        }

        // Populate Select from Catalog (Official Source)
        const select = container.querySelector('#hist-item-select');
        select.innerHTML = '<option value="">Carregando...</option>'; // Spinner state

        // Filter ONLY Items (Exclude Categories)
        const allData = window.FazendaRP.SuprimentosData || [];
        const items = allData.filter(i => i.tipo === 'ITEM');

        // Sort alphabetically
        items.sort((a, b) => a.nome.localeCompare(b.nome));

        select.innerHTML = '<option value="">Selecione um item...</option>' +
            items.map(i => `<option value="${i.id}" data-nome="${i.nome}" data-unit="${i.unidades ? i.unidades[0] : 'UN'}">${i.nome}</option>`).join('');

        // Event Listener
        select.addEventListener('change', (e) => {
            const opt = select.options[select.selectedIndex];
            if (opt.value) {
                this.loadItemHistory(parseInt(opt.value), opt.dataset.nome, opt.dataset.unit);
            }
        });

        // Ensure Partners are Loaded (Fix for "Unknown Supplier")
        if (!window.FazendaRP.ParceirosData || window.FazendaRP.ParceirosData.length === 0) {
            console.log("Histórico: Carregando cache de parceiros...");
            const { data: parceiros } = await window.FazendaRP.supabase.from('parceiros').select('id, nome');
            if (parceiros) {
                window.FazendaRP.ParceirosData = parceiros;
            }
        }
    },

    loadItemHistory: async function (itemId, itemName, unit) {
        this.selectedItemId = itemId;
        const container = document.getElementById('hist-table-body');
        if (!container) return;

        container.innerHTML = '<tr><td colspan="5" style="text-align:center; padding:20px; color:#64748b;"><i class="fas fa-spinner fa-spin"></i> Carregando dados...</td></tr>';

        try {
            console.log("Histórico: Buscando compras do item", itemId);

            // 1. Fetch Data (Client-Side Filtering for Reliability)
            const { data, error } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('id, data_emissao, parceiro_id, detalhes, valor')
                .eq('tipo', 'Despesa')
                .neq('status', 'Cancelado')
                .order('data_emissao', { ascending: false })
                .limit(100000); // Fetch ALL history (Practical limit for full coverage)

            if (error) throw error;

            if (!data || data.length === 0) {
                container.innerHTML = '<tr><td colspan="5" style="text-align:center; padding:30px; color:#94a3b8;">Nenhum lançamento encontrado recentemente.</td></tr>';
                this.updateMetrics(0, 0, 0, unit, null);
                this.renderChart([], unit);
                return;
            }

            // 2. Process Data
            const history = [];

            for (const lanc of data) {
                // Robust Match: Loose equality for string/int mismatches
                if (!lanc.detalhes || !lanc.detalhes.itens) continue;

                // Try matching by ID first, then by Name (case insensitive for safety)
                // This covers: Saved with ID, or Saved as manual text "Diesel S10" without ID
                const itemDetail = lanc.detalhes.itens.find(i =>
                    (i.id && i.id == itemId) ||
                    (i.nome && itemName && i.nome.trim().toLowerCase() === itemName.trim().toLowerCase())
                );

                if (itemDetail) {
                    // Resolve Partner Name
                    let supplierName = 'Desconhecido';
                    // Use Global Cache (Now guaranteed to be loaded or at least attempted)
                    if (window.FazendaRP.ParceirosData) {
                        // Loose quality check (string vs int)
                        const p = window.FazendaRP.ParceirosData.find(x => x.id == lanc.parceiro_id);
                        if (p) supplierName = p.nome;
                    }

                    history.push({
                        date: lanc.data_emissao,
                        supplier: supplierName,
                        qty: parseFloat(itemDetail.qtd),
                        unitPrice: parseFloat(itemDetail.valor_unitario || (itemDetail.total / itemDetail.qtd)),
                        total: parseFloat(itemDetail.total)
                    });
                }
            }

            // 3. Render Table
            if (history.length === 0) {
                container.innerHTML = '<tr><td colspan="5" style="text-align:center; padding:30px; color:#94a3b8;">Nenhuma compra encontrada para este item nas últimas 2000 despesas.</td></tr>';
                // Reset metrics
                this.updateMetrics(0, 0, 0, unit, null);
                this.renderChart([], unit);
                return;
            }

            container.innerHTML = history.map(h => `
                <tr style="border-bottom: 1px solid #f1f5f9; transition: background 0.1s;">
                    <td style="padding: 12px; color: #334155;">${h.date ? h.date.split('-').reverse().join('/') : '-'}</td>
                    <td style="padding: 12px; font-weight: 500; color: #1e293b;">${h.supplier}</td>
                    <td style="padding: 12px; text-align: right; color: #475569;">${h.qty.toLocaleString('pt-BR')} <span style="font-size:0.8em; color:#94a3b8;">${unit}</span></td>
                    <td style="padding: 12px; text-align: right; color: #475569;">${h.unitPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding: 12px; text-align: right; font-weight: 600; color: #059669;">${h.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            `).join('');

            // 4. Calculate Metrics
            const totalQty = history.reduce((sum, h) => sum + h.qty, 0);
            const totalSpent = history.reduce((sum, h) => sum + h.total, 0);
            const avgPrice = totalQty > 0 ? (totalSpent / totalQty) : 0;
            const lastPurchase = history[0];

            this.updateMetrics(avgPrice, lastPurchase ? lastPurchase.unitPrice : 0, totalSpent, unit, lastPurchase ? lastPurchase.date : null);

            // 5. Render Chart
            this.renderChart(history, unit);

        } catch (err) {
            console.error(err);
            container.innerHTML = `<tr><td colspan="5" style="text-align:center; padding:20px; color:red;">Erro ao carregar: ${err.message}</td></tr>`;
        }
    },

    updateMetrics: function (avg, last, totalSpent, unit, lastDate) {
        document.getElementById('kpi-avg-price').innerText = avg.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        document.getElementById('kpi-last-price').innerText = last.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        document.getElementById('kpi-total-spent').innerText = totalSpent.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        // Extra info
        if (lastDate) {
            const dateObj = new Date(lastDate);
            dateObj.setMinutes(dateObj.getMinutes() + dateObj.getTimezoneOffset());
            document.getElementById('kpi-last-date').innerText = dateObj.toLocaleDateString('pt-BR');
        } else {
            document.getElementById('kpi-last-date').innerText = '-';
        }

        // We stored Total Qty in the Total Spent card's subtitle - NOW MOVED to own card
        const totalQty = (avg > 0) ? (totalSpent / avg) : 0; // Better calc if available or pass totalQty directly? 
        // Logic issue: avg = totalSpent / totalQty. So totalQty = totalSpent / avg. Correct.
        // But cleaner if we calculated totalQty in `loadItemHistory` and passed it. Use existing flow for now.

        document.getElementById('kpi-total-qty').innerText = `${totalQty.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ${unit}`;
    },

    renderChart: function (history, unit) {
        const ctx = document.getElementById('hist-price-chart');
        if (!ctx) return;

        // Prepare Data (Reverse for Chronological Order)
        const sorted = [...history].sort((a, b) => new Date(a.date) - new Date(b.date));
        const labels = sorted.map(h => {
            const d = new Date(h.date);
            d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
            return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
        });
        const dataPoints = sorted.map(h => h.unitPrice);

        if (this.chartInstance) {
            this.chartInstance.destroy();
        }

        this.chartInstance = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: `Preço Unitário (${unit})`,
                    data: dataPoints,
                    borderColor: '#3b82f6',
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    pointRadius: 4,
                    pointBackgroundColor: '#fff',
                    pointBorderColor: '#3b82f6'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            label: (ctx) => `R$ ${ctx.raw.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: false,
                        grid: { borderDash: [2, 4], color: '#f1f5f9' },
                        ticks: { callback: (val) => 'R$ ' + val }
                    },
                    x: {
                        grid: { display: false }
                    }
                }
            }
        });
    }
};
